export default "__VITE_ASSET__CCB4Tj_J__"